import { ChatBot, ThirdPartyChatbotConfiguration } from 'apis/chatbots';

export function isThirdPartyChatbot(
  chatbot?: ChatBot,
): chatbot is ThirdPartyChatbotConfiguration {
  return chatbot
    ? chatbot._type === 'ada' ||
        chatbot._type === 'digitalgenius' ||
        chatbot._type === 'kindly'
    : false;
}
